import RedactionSearchOverlay from './RedactionSearchOverlayContainer';

export default RedactionSearchOverlay;